import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ClipboardCheck, Pencil } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useFetch } from "@/lib/hooks";
import { can, fmtDate, km } from "@/lib/format";
import { Empty, Info, Loading, PageHeader, Panel, StatusBadge } from "@/components/common";
import { VehicleDialog } from "@/components/forms";
import { Button } from "@/components/ui/button";

export default function VehicleDetail() {
  const { id } = useParams();
  const { user } = useAuth();
  const { data: v, reload } = useFetch<any>(`/vehicles/${id}`);
  const [edit, setEdit] = useState(false);
  if (!v) return <Loading />;
  return (
    <div>
      <PageHeader eyebrow={`${v.brand} ${v.model} ${v.year || ""}`} title={v.plate}
        actions={<>
          {can(user?.role, "clients_write") && <Button variant="outline" onClick={() => setEdit(true)} data-testid="edit-vehicle-btn"><Pencil className="mr-2 h-4 w-4" />Modifier</Button>}
          {can(user?.role, "reception") && <Link to={`/receptions/nouvelle?vehicle=${v.id}`}><Button data-testid="vehicle-new-reception-btn"><ClipboardCheck className="mr-2 h-4 w-4" />Réceptionner</Button></Link>}
        </>} />
      <div className="grid gap-6 lg:grid-cols-3">
        <Panel title="Fiche véhicule">
          <div className="grid grid-cols-2 gap-5">
            <Info label="VIN" value={<span className="font-mono-data text-xs">{v.vin}</span>} testId="vehicle-vin" />
            <Info label="Énergie" value={v.fuel} />
            <Info label="Couleur" value={v.color} />
            <Info label="Dernier kilométrage" value={km(v.mileage)} />
            <Info label="Propriétaire" value={v.client && <Link className="text-primary underline" to={`/clients/${v.client.id}`}>{v.client.name}</Link>} />
          </div>
        </Panel>
        <Panel title="Historique des passages" className="lg:col-span-2" testId="vehicle-history">
          {v.receptions.length === 0 ? <Empty text="Aucun passage à l'atelier" /> : v.receptions.map((r: any) => {
            const o = v.orders.find((x: any) => x.reception_id === r.id);
            return (
              <Link key={r.id} to={`/receptions/${r.id}`} className="grid grid-cols-[1fr_auto] gap-2 border-b border-border py-3 last:border-0 hover:bg-accent/40">
                <div>
                  <div className="text-sm"><span className="font-mono-data font-semibold">{r.number}</span> · {fmtDate(r.created_at)} · {km(r.mileage)}</div>
                  <div className="text-xs text-muted-foreground">{r.customer_request}{o ? ` — OR ${o.number} (${o.tasks.map((t: any) => t.label).join(", ")})` : ""}</div>
                </div>
                <StatusBadge status={r.status} />
              </Link>
            );
          })}
        </Panel>
      </div>
      <VehicleDialog open={edit} onOpenChange={setEdit} clientId={v.client_id} initial={v} onSaved={reload} />
    </div>
  );
}
